import { BaseStationFieldName } from '../base-stations-listing-page.types';

export const BASE_STATION_SORT_FIELD: Record<string, BaseStationFieldName> = {
  deviceId: BaseStationFieldName.DeviceUId,
  deviceType: BaseStationFieldName.DeviceType,
  provisioningStatus: BaseStationFieldName.ProvisioningStatus,
  macId: BaseStationFieldName.MacId,
  backhaulConnectionConfigured: BaseStationFieldName.BackhaulConnectionConfigured,
  RanConfigured: BaseStationFieldName.RanConfigured,
  provisioningDateTime: BaseStationFieldName.ProvisioningDateTimeUtc,
  installedBy: BaseStationFieldName.InstalledBy
};
